export default __webpack_public_path__ + "assets/897272955a6d6aec5ece9509b3787900/03.jpg";